var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('div',{staticClass:"notice-box"},[_c('div',{staticClass:"container clearfix"},[_vm._v("\n    公告："),_c('span',{domProps:{"innerHTML":_vm._s(_vm.notice.content)}}),_vm._v(" "),_c('span',{staticClass:"notice-close",on:{"click":_vm.close}},[_vm._v("【关闭】")])])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ee331ac6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/header/Notice.vue
// module id = null
// module chunks = 